import { gql, useMutation } from '@apollo/client';

import {
  DraftJobsDocument,
  type DeleteDraftJobMutation,
  type DeleteDraftJobMutationVariables,
} from 'src/graphql/__generated__';

import { useGetQueryDraftJobsOptions } from './useQueryDraftJobs';

export const DELETE_DRAFT_JOB_MUTATION = gql`
  mutation DeleteDraftJob($input: DeleteDraftJobInput!) {
    deleteDraftJob(input: $input) {
      successful
    }
  }
`;

export const useMutateDeleteDraftJob = (jobId: string) => {
  const options = useGetQueryDraftJobsOptions();

  const [deleteDraftJobFunction, { data, loading, error }] = useMutation<
    DeleteDraftJobMutation,
    DeleteDraftJobMutationVariables
  >(DELETE_DRAFT_JOB_MUTATION, {
    refetchQueries: [
      {
        query: DraftJobsDocument,
        ...options,
      },
    ],
    awaitRefetchQueries: true,
  });
  return {
    deleteDraftJob: () =>
      deleteDraftJobFunction({
        variables: {
          input: {
            id: jobId,
          },
        },
      }),
    data,
    loading,
    error,
  };
};
